/** Phase 2 (W1): Home in sections, period picker, top bar with indices and environment strip. */
export const inicioEn = {
  inicio: {
    kicker: 'Overview',
    titulo: 'Hello, {{nome}}',
    indicadores: 'Indicators',
    semIndicadores: 'Install modules to see indicators here.',
    secoes: { financeiro: 'Finance', comercial: 'Sales', operacao: 'Operations', pessoas: 'People and learning', sistema: 'System' },
    etiqueta: { hoje: 'Today', agora: 'Now', periodo: 'Period' },
    base: { caixa: 'Cash', competencia: 'Reference month', emissao: 'Issue date' },
    verDetalhes: 'View details',
    delta: {
      acima: '{{pct}} above the previous period',
      abaixo: '{{pct}} below the previous period',
      igual: 'Same as the previous period',
      semAnterior: 'No value in the previous period',
      anterior: 'Previous period: {{valor}}',
    },
    motivo: { erro: 'This value could not be calculated right now. Try again in a moment.', tempo: 'The calculation took too long. Try again in a moment.' },
    vazio: { padrao: 'No data yet', lista: 'Nothing to show right now', grafico: 'No activity in the period' },
    acoesRapidas: 'Quick actions',
    acoes: {
      fatura: 'New invoice',
      contaPagar: 'New bill',
      lancamento: 'New entry',
      cliente: 'New customer',
      oportunidade: 'New opportunity',
      contrato: 'New contract',
      agendamento: 'Book meeting',
      tarefa: 'New task',
      compra: 'New purchase',
      pedidoCompra: 'New purchase order',
      produto: 'New product',
      funcionario: 'New employee',
      curso: 'New course',
    },
    grafico: {
      entradas: 'Inflows',
      saidas: 'Outflows',
      saldo: 'Running balance',
      previsto: 'Expected balance',
      previstoLegenda: 'Expected balance (with open items)',
      aria: 'Cash flow from {{de}} to {{ate}}, running balance at the end of {{saldo}}',
      tabela: 'Cash flow chart data',
      data: 'Date',
      semana: 'Week of {{data}}',
    },
    lista: {
      fatura: 'Receivable',
      conta_pagar: 'Payable',
      diasAtraso_one: '{{count}} day overdue',
      diasAtraso_other: '{{count}} days overdue',
      sem_categoria: 'No category',
      outras: 'Other categories',
      autor: { sistema: 'System', chave: 'API key' },
    },
    cards: {
      a_receber_semana: { rotulo: 'Receivable', partes: { vencido: 'Overdue', hoje: 'Due today', proximos_7: 'Next 7 days' } },
      recebido_periodo: { rotulo: 'Received in the period' },
      a_pagar: { rotulo: 'Payable', partes: { vencido: 'Overdue', hoje: 'Due today', proximos_7: 'Next 7 days' } },
      pago_periodo: { rotulo: 'Paid in the period' },
      saldo_contas: { rotulo: 'Account balance', subtitulo_one: '{{count}} active account', subtitulo_other: '{{count}} active accounts' },
      resultado_caixa: { rotulo: 'Cash result', partes: { entradas: 'Inflows', saidas: 'Outflows' } },
      resultado_competencia: { rotulo: 'Monthly result (accrual)', partes: { entradas: 'Revenue', saidas: 'Expenses' } },
      fluxo_caixa: { rotulo: 'Cash flow', valor: 'Balance at the end of the period', partes: { entradas: 'Inflows in the period', saidas: 'Outflows in the period', previsto: 'Expected balance at the end of the period' } },
      faturamento_emitido: { rotulo: 'Invoiced amount' },
      despesas_categoria: { rotulo: 'Expenses by category', vazio: 'No expenses paid in the period' },
      proximos_vencimentos: { rotulo: 'Upcoming due dates', vazio: 'Nothing due in the next 15 days' },
      maiores_devedores: { rotulo: 'Top debtors', vazio: 'No customer with overdue items' },
      conciliacao_pendente: { rotulo: 'To check with the bank', partes: { entradas: 'Inflows to check with the bank', saidas: 'Outflows to check with the bank' } },
      oportunidades_abertas: { rotulo: 'Sales in progress', partes: { quantidade: 'Open opportunities' } },
      ganhas_periodo: { rotulo: 'Won in the period', partes: { quantidade: 'Opportunities won', conversao: 'Conversion rate' } },
      conversas_nao_lidas: { rotulo: 'Unread conversations', partes: { minhas: 'Assigned to me', sem_dono: 'Unassigned' } },
      clientes_ativos: { rotulo: 'Active customers', partes: { novos_periodo: 'New in the period' } },
      agenda_hoje: { rotulo: "Today's schedule", subtitulo: 'Next at {{hora}}' },
      estoque_abaixo_minimo: { rotulo: 'Stock below minimum' },
      compras_a_receber: { rotulo: 'Purchases to receive', partes: { atrasados: 'Late delivery' } },
      funcionarios_ativos: { rotulo: 'Active employees', partes: { admissoes: 'Hires in the period', desligamentos: 'Terminations in the period' } },
      folha_ultima: { rotulo: 'Payroll', subtitulo: 'Net pay for {{mes}}', vazio: 'No closed payroll yet' },
      documentos_vencendo: { rotulo: 'Documents expiring in 30 days', partes: { vencidos: 'Already expired' } },
      treinamento_em_andamento: { rotulo: 'Trainings in progress' },
      conectores_ativos: { rotulo: 'Connected connectors', partes: { com_erro: 'With errors' } },
      atividade_recente: { rotulo: 'Recent activity', vazio: 'No activity recorded yet' },
      mrr: { rotulo: 'Monthly recurring revenue (MRR)', partes: { pausado: 'Paused recurring revenue', a_iniciar: 'Recurring revenue to start' }, vazio: 'No recurring contract yet' },
      reajustes_pendentes: { rotulo: 'Pending adjustments' },
      minhas_tarefas: { rotulo: 'My open tasks', partes: { atrasadas: 'Past due', p1: 'Priority P1' } },
      cards_parados: { rotulo: 'Cards stuck for more than 7 days', partes: { esperando_pessoa: 'Waiting for a decision', mais_14: 'Stuck for more than 14 days' } },
      novidades: { rotulo: "What's new", naoVistas_one: "{{count}} update you haven't seen yet", naoVistas_other: "{{count}} updates you haven't seen yet", emDia: "You've seen all the updates", nova: 'New', verTodas: 'See all updates' },
    },
  },
  periodo: {
    escolher: 'Choose period',
    atual: 'Period: {{rotulo}}',
    atalhos: {
      hoje: 'Today',
      semana: 'This week',
      mes: 'This month',
      mes_passado: 'Last month',
      '30_dias': 'Last 30 days',
      trimestre: 'This quarter',
      ano: 'This year',
      personalizado: 'Custom',
    },
    de: 'From',
    ate: 'To',
    aplicar: 'Apply',
    invalido: 'Choose a start date before the end date, up to 3 years.',
    aplicarPeriodo: 'Apply range',
    mes: 'Month',
    mesAno: '{{mes}} / {{ano}}',
    mesInvalido: 'Choose a valid month.',
    rotuloAbas: 'Period type',
    abas: { atalhos: 'Shortcuts', mes: 'Specific month', periodo: 'Range' },
  },
  // U15 F8: atalho rápido do topo.
  atalho: {
    abrir: 'Quick add',
    titulo: 'Quick add',
    oQue: 'What to add',
    novaTarefa: 'New task',
    mensagemEquipe: 'Message to the team',
    salvarTarefa: 'Save task',
    enviarMensagem: 'Send message',
    escolha: 'Choose the person or channel',
    para: 'To',
    mensagem: 'Message',
    canal: 'channel',
    tarefaCriada: 'Task created',
    verTarefa: 'View task',
    mensagemEnviada: 'Message sent',
    abrirConversa: 'Open conversation',
  },
  barra: {
    titulo: 'Top bar',
    indices: 'Indices',
    regiao: 'Central Bank of Brazil economic indices',
    nomes: { igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
    mes12: '12m',
    acumulado: 'accumulated over 12 months: {{valor}}',
    atualizado: 'Updated on {{data}}',
    vazio: 'Central Bank indices show up here after the first sync.',
    erro: 'Indices unavailable right now.',
    ocultar: 'Hide indices',
    mostrar: 'Show indices',
    atualizarAgora: 'Update indices now',
    atualizacaoPedida: 'Update requested from the Central Bank. The indices show up in a moment.',
    recolherMenu: 'Collapse side menu',
    expandirMenu: 'Expand side menu',
  },
  ambiente: {
    rotulo: 'Environment notice',
    homologacao: 'Acceptance environment. Test data.',
    staging: 'Staging environment. Test data.',
    sandbox: 'Sandbox: test data, nothing here affects real operations.',
  },
  // Lote 19 (item 13): split screen.
  divisao: {
    abrirAoLado: 'Open side by side',
    abrirEmAba: 'Open in another panel tab',
    tituloAbrir: 'Open this screen side by side (Ctrl+Alt+Right arrow)',
    barra: 'Split screen',
    painel: 'Panel {{n}}',
    emUso: 'In use',
    painelEmUso: 'Panel {{n}}, in use',
    divisoria: 'Divider between the panels',
    proporcao: 'Panel 1 at {{p}}% of the width',
    trocar: 'Swap sides',
    fechar: 'Close panel {{n}}',
    opcoesDoItem: 'Options for {{item}}',
    // 30/10 list B (item 2 of the Main workspace record): the fixed button on the top bar.
    botaoBarra: 'Split screen',
    dicaLigar: 'Split the screen into two panels, each with its own sub-system (Ctrl+Alt+right arrow)',
    dicaDesligar: 'Back to a single panel',
  },
};
